// Single source of truth for semantic mappings (status / priority / type
// -> Vuetify theme color + icon). Imported by both the formatMixin and the
// shared chip components so chips and inline text never drift apart.

export const STATUS_COLORS = {
  // Sprint / project tickets
  Todo: 'neutral',
  'In Progress': 'info',
  'On Hold': 'warning',
  Cancelled: 'error',
  Done: 'success',
  // IT tickets
  Open: 'error',
  Resolved: 'success',
  Closed: 'neutral',
  // QA execution results
  Pass: 'success',
  Fail: 'error',
  Blocked: 'warning',
  Skipped: 'neutral',
  Untested: 'neutral',
};

export const PRIORITY_COLORS = {
  lowest: 'neutral',
  low: 'info',
  medium: 'warning',
  high: 'error',
  critical: 'error',
  urgent: 'error',
};

export const PRIORITY_ICONS = {
  lowest: 'mdi-chevron-double-down',
  low: 'mdi-arrow-down',
  medium: 'mdi-arrow-right',
  high: 'mdi-arrow-up',
  critical: 'mdi-chevron-double-up',
  urgent: 'mdi-chevron-double-up',
};

export const TYPE_COLORS = {
  IT: 'warning',
  QA: 'qa',
  Sprint: 'primary',
};

export function statusColor(status) {
  return STATUS_COLORS[status] || 'neutral';
}
export function priorityColor(priority) {
  return PRIORITY_COLORS[String(priority || '').toLowerCase()] || 'neutral';
}
export function priorityIcon(priority) {
  return PRIORITY_ICONS[String(priority || '').toLowerCase()] || 'mdi-arrow-right';
}
export function typeColor(type) {
  return TYPE_COLORS[type] || 'neutral';
}
